import { h } from 'preact';
import { getImageDimensions, calcImagePositionForFocalPoint } from 'utils/media';

import MovieList from 'components/list/movieList/movieList.js';

export default class FocusMovieList extends MovieList {
	defaultHeroImage = `${__IMAGE_ROOT__}/heros/focus-hero-default.jpg`;

	constructor(props) {
		super(props);

		// Pre-calculate background positions for all items to optimize rendering
		this.setBackgroundPositions(this.getItems());
	}

	async setBackgroundPositions(items) {
		const getBackgroundPosition = async (item) => {
			const [containerWidth, containerHeight] = [264, 200]; // fixed size
			const { focalPoint, url } = this.getHeroImage(item) || {};
			const { focalX, focalY } = focalPoint || {};
			const { width, height } = await getImageDimensions(url);
			return calcImagePositionForFocalPoint(width, height, containerWidth, containerHeight, focalX, focalY);
		};
	
		// Get background positions for all items as an array of promises
		const loadAllBackgroundPositions = items
			.filter(item => item.content.hero?.still?.focalPoint)
			.map(async item => [item.id, await getBackgroundPosition(item)]);
			// Wait for all background positions to load
		const backgroundPositionsArray = await Promise.all(loadAllBackgroundPositions);
		// Convert the array of [id, position] pairs into an object
		const backgroundPositions = Object.fromEntries(backgroundPositionsArray);
	
		this.setState({ backgroundPositions });
	}

	getHeroImage(item) {
		const focusHero = item?.content?.hero?.still || {};
		return focusHero?.url ? focusHero : { url: this.defaultHeroImage };
	}
}